export default __webpack_public_path__ + "static/og-hackathon-4-2ea9383e1cd436e634cf747c152c73a5.jpg";